"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalHeaderTab", {
    enumerable: true,
    get: function() {
        return ModalHeaderTab;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _SelectedContext = require("../../../contexts/SelectedContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalHeaderTab = (param)=>{
    let { children, className, eventKey } = param;
    const ctx = (0, _react.useContext)(_SelectedContext.SelectedContext);
    const selectedClass = ctx.selected === eventKey ? "selected" : "";
    const onSelect = (0, _react.useCallback)(()=>{
        ctx.setSelected(eventKey);
    }, [
        ctx,
        eventKey
    ]);
    return /*#__PURE__*/ _react.default.createElement("a", {
        tabIndex: 0,
        onClick: onSelect,
        className: "jsx-2e91b68a00e55356" + " " + "text-dark ".concat(className !== null && className !== void 0 ? className : "", " ").concat(selectedClass)
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "2e91b68a00e55356"
    }, "a.jsx-2e91b68a00e55356{display:inline-block;font-size:14px;font-weight:bold;cursor:pointer;opacity:.5;border-bottom:1px solid#fff;padding:.5rem 0;margin:0 .5rem}a.jsx-2e91b68a00e55356,a.jsx-2e91b68a00e55356:hover,a.jsx-2e91b68a00e55356:focus,a.jsx-2e91b68a00e55356:active,a.jsx-2e91b68a00e55356:visited{text-decoration:none}a.jsx-2e91b68a00e55356:first-child{margin-left:0}a.jsx-2e91b68a00e55356:hover{opacity:1}.selected.jsx-2e91b68a00e55356{opacity:1;border-color:#000}"));
};

//# sourceMappingURL=ModalHeaderTab.js.map